import React, { Component } from "react";
import "./contacto.css";
import { EditorState, convertToRaw } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import draftToHtml from "draftjs-to-html";
// import htmlToDraft from "html-to-draftjs";
import "../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { FormGroup, Grid, Row, Col, Image, Button } from "react-bootstrap";

export default class Contacto extends Component {
  constructor(props) {
    super(props);
    this.state = {
      nombre: "",
      email: "",
      message: "",
      phone: "",
      editorState: EditorState.createEmpty()
    };
  }
  componentWillMount() {}
  handelSubmit(e) {
    if (!this.state.email || !this.state.nombre) {
      e.preventDefault();
      e.stopPropagation();
      alert("Favor de llenar los campos necesarios");
    } else {
      var body = JSON.stringify({
        to: "editorialtyr@gmail.com",
        subject: "Contact T&R Editorial",
        html:
          '<table style="width: 100%;"><tbody><tr><td style="width: 50.0000%;">de:</td><td style="width: 50.0000%;">' +
          this.state.nombre +
          "<br>" +
          this.state.email +
          "<br>" +
          this.state.phone +
          '</td></tr><tr><td style="width: 50.0000%;">mensaje: </td><td style="width: 50.0000%;">' +
          draftToHtml(
            convertToRaw(this.state.editorState.getCurrentContent())
          ) +
          "</td></tr></tbody></table>"
      });
      console.log(body);
      e.preventDefault();
      e.stopPropagation();
      fetch("https://shielded-scrubland-72467.herokuapp.com/mail", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: body
      })
        .then(response => {
          if (response.status === 200) {
            alert("Tu mensaje se ha enviado con exito");
          } else {
            alert("Error al mandar email contactar: editorialtyr@gmail.com");
          }
        })
        .catch(error => {
          console.error(error);
          alert("Error al mandar email contactar: editorialtyr@gmail.com");
        });
    }
  }
  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }
  onEditorStateChange(state) {
    this.setState({ editorState: state });
  }
  render() {
    return (
      <div className="navMargin" style={{ height: "100%" }}>
        <section
          style={{
            paddingTop: "2%",
            backgroundColor: "#352a35",
            display: "flex",
            flexDirection: "column",
            height: "auto",
            minHeight: "100%"
          }}
        >
          <p
            style={{
              color: "white",
              textAlign: "center",
              fontSize: "60pt",
              fontWeight: "Bold"
            }}
          >
            Contáctanos
          </p>
          <Image
            src={require("../../img/lineContacto.png")}
            style={{
              marginLeft: "auto",
              marginRight: "auto",
              display: "block"
            }}
            responsive
          />
          <div style={{ height: 50 }} />
          <form
            method="POST"
            onSubmit={this.handelSubmit.bind(this)}
          >
            <Grid>
              <Row>
                <Col xs={12} md={6}>
                  <FormGroup>
                    <input
                      className="form-control"
                      type="nombre"
                      name="nombre"
                      placeholder="Tu Nombre*"
                      value={this.state.nombre}
                      onChange={this.handleChange.bind(this)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <input
                      className="form-control"
                      type="email"
                      name="email"
                      placeholder="Tu Correo Electrónico*"
                      value={this.state.email}
                      onChange={this.handleChange.bind(this)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <input
                      className="form-control"
                      type="phone"
                      name="phone"
                      placeholder="Tu Teléfono*"
                      value={this.state.phone}
                      onChange={this.handleChange.bind(this)}
                    />
                  </FormGroup>
                </Col>
                <Col xs={12} md={6}>
                  <Editor
                    editorState={this.state.editorState}
                    wrapperClassName="wrapper-class"
                    editorClassName="rdw-storybook-editor"
                    onEditorStateChange={this.onEditorStateChange.bind(this)}
                  />
                </Col>
              </Row>
            </Grid>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                marginTop: 50,
                marginBottom: 50
              }}
            >
              <Button
                bsStyle="primary"
                bsSize="large"
                bsClass="btn rouded2"
                type="submit"
              >
                ESCRÍBENOS
              </Button>
            </div>
          </form>
        </section>
      </div>
    );
    // <div className="navMargin container">
    //   <h2>Contacto</h2>
    //   <form method="POST" onSubmit={this.handelSubmit.bind(this)} onKeyDown={(e)=>{if(e.key==="Enter"){this.handelSubmit.bind(this)}}}>
    //     <input type="email" name="email" placeholder="Your email" value={this.state.email} onChange={this.handleChange.bind(this)}/>
    //     <button type="submit">Enviar</button>
    //   </form>
    //   <Editor
    //     editorState={this.state.editorState}
    //     wrapperClassName="wrapper-class"
    //     editorClassName="rdw-storybook-editor"
    //     onEditorStateChange={this.onEditorStateChange.bind(this)}
    //   />
    // </div>
  }
  componentDidMount() {}
  componentWillUnmount() {}
}



// WEBPACK FOOTER //
// ./src/views/contacto/index.js